/*
 * How they heard about us (owner, 2026-11-04, after the branding research: "how did you hear about us" on every quote form
 * and call). One short list the website forms, the office and the reports share. It is the person's own answer; the
 * request's source (website, google_ads and the rest) is where the click came from, and stays as it is.
 */
export const HEARD_FROM = [
  "Google",
  "Facebook or Instagram",
  "A friend or neighbor",
  "Saw our truck",
  "Yard sign",
  "Door hanger or mail",
  "Nextdoor",
  "Past client",
  "Other",
] as const;
export type HeardFrom = (typeof HEARD_FROM)[number];

const WORDS: [RegExp, HeardFrom][] = [
  [/nextdoor|next door/i, "Nextdoor"],
  [/google|search|maps?\b|online|internet|web/i, "Google"],
  [/facebook|\bfb\b|instagram|\big\b|meta|social/i, "Facebook or Instagram"],
  [/friend|neighbou?r|family|referr|word of mouth|recommend/i, "A friend or neighbor"],
  [/truck|van|trailer|car\b|vehicle|crew/i, "Saw our truck"],
  [/sign/i, "Yard sign"],
  [/door|hanger|mail|postcard|flyer|flier/i, "Door hanger or mail"],
  [/before|again|past|used you|client|customer/i, "Past client"],
];

/** A form's free answer ("my neighbor Tina", "google maps") as one of the list, or null when there is no answer. */
export function heardFromOf(said: string | null | undefined): HeardFrom | null {
  const t = (said ?? "").trim();
  if (!t) return null;
  const exact = HEARD_FROM.find((h) => h.toLowerCase() === t.toLowerCase());
  if (exact) return exact;
  return WORDS.find(([re]) => re.test(t))?.[1] ?? "Other";
}
